<template>
    <table>
        <thead>
            <tr>
                <DataTableHeader class="column" v-for="header in tableHeader" :key="header.label" :header="header"></DataTableHeader>
            </tr>
        </thead>
        <tbody v-if="tableData.length > 0">
            <tr v-for="items in tableData" :key="items.id">
                <td
                    v-for="(item, i) in getVisibleItems(Object.entries(items))"
                    :key="item[0]"
                    :style="getStyle(tableHeader[i])"
                >
                    <div v-if="item[0] === 'facture'">
                      <AddDocuments :documents="[]" @add="addFile" v-if='item[1] === undefined && isLastItem(items)'/>
                      <div v-else>
                        <span v-if='item[1] === undefined'></span>
                        <span v-else>
                          {{item[1].name}}
                          <img  v-if='isLastItem(items)'
                                class="trash-icon"
                                :src="deleteIcon"
                                alt="delete"
                                @click="deleteFacture()"/>
                        </span>
                      </div>
                    </div>
                    <div v-else-if="item[0] === 'numeroCompteur'">
                      <input v-model='numeroCompteur' v-if='isLastItem(items)'>
                      <span v-else>{{ item[1] }}</span>
                    </div>
                </td>
                <td>
                  <div>
                    <img  v-if='!isLastItem(items)'
                          class="pointer"
                          :src="deleteIcon"
                          alt="delete"
                          @click="deleteRow(items)"/>
                  </div>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script lang="ts">
import { SortType } from '@/models/SortType';
import { TableHeader } from '@/models/TableHeader';
import { defineComponent, PropType } from 'vue';
import DataTableHeader from '@/components/ui-components/DataTableHeader.vue';
import AddDocuments from '@/modules/Common/components/AddDocuments.vue';
import { COMPTEUR } from '@/modules/Outils/store/mutation-types';
import { Compteur } from '@/modules/Outils/store/state';

export default defineComponent({
    name: 'DataTable',
    components: { DataTableHeader, AddDocuments },
    setup() {
        return {
            SortType,
        };
    },
    props: {
        tableData: { type: Array, required: true },
        tableHeader: { type: Array as PropType<TableHeader[]>, required: true },
        count: { type: Number, required: true },
    },
    methods: {
        getVisibleItems(items: any[]) {
            return items.filter(i => i[0].indexOf('invisible')==-1);
        },
        getStyle(tableHeader: TableHeader) {
            let css = '';
            if(tableHeader.width){
                css += 'width: '+tableHeader.width+';';
            }
            if(tableHeader.textalign){
                css += 'text-align: '+tableHeader.textalign+';';
            }
            return css;
        },
        deleteFacture() {
          this.$store.commit(COMPTEUR.REMOVE_FACTURE);
        },
        addFile(file: File) {
          this.$store.commit(COMPTEUR.ADD_FACTURE, file);
        },
        isLastItem(item: Compteur): boolean{
          return this.$store.getters.getCompteurs[(this.count - 1)] === item;
        },
        deleteRow(compteur: Compteur) {
          this.$store.commit(COMPTEUR.REMOVE_COMPTEUR, compteur);
        }
    },
    computed: {
        pdfIcon() {
            return require('@/assets/img/pdf-icon.svg');
        },
        checkBoxIcon() {
            return require('@/assets/img/valid2.svg');
        },
        numeroCompteur: {
          get(): string {
            return this.$store.getters.getCompteurs[(this.count - 1)].numeroCompteur;
          },
          set(value: string) {
            this.$store.commit(COMPTEUR.SET_NUMERO_COMPTEUR, value.trim());
          },
        },
        deleteIcon() {
          return require('@/assets/img/delete.svg');
        },
    },
});
</script>

<style scoped>
table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    border-right: 1px solid var(--medium-dark-grey);
    border-left: 1px solid var(--medium-dark-grey);
    border-bottom: 1px solid var(--medium-dark-grey);
    text-align: left;
    font-variant-numeric: lining-nums;
}

table thead {
    top: 0;
    font-size: 14px;
    color: var(--dark-grey);
    font-family: 'Raleway Semi Bold', sans-serif !important;
    font-variant-numeric: lining-nums;
}

table thead th {
    top: 0;
    border-bottom: 1px solid var(--medium-dark-grey);
    border-top: 1px solid var(--medium-dark-grey);
    background-color: white;
    height: 55px;
    white-space: pre-line;
}

table tr td {
    border-bottom: 1px solid var(--medium-dark-grey);
    height: 55px;
    padding: 0 15px;
    overflow: hidden;
}

table tr td span {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: keep-all;
    overflow: hidden;
}

table thead tr:first-child {
    border-top: none;
}

table tr * {
    box-sizing: border-box;
    padding: 0 5px;
}
:deep(.form-documents) {
  width: 100%;
}
:deep(.add-button) {
  margin-bottom: 0;
}
.pointer {
  cursor: pointer;
}
</style>
